export default __webpack_public_path__ + "static/media/Conscript's Chestguard of the Watchtowers.e36fa9a0.jpg";